/**
 * Lodestone JavaScript Bundle
 * Entry point that exports all modules for use in templates
 *
 * This bundle is loaded via <script> tag — only window.Lodestone assignments matter.
 * No ES module consumers exist, so we skip named re-exports.
 */

// Import modules for window exposure
import { getThemeMapStyle, createHoverMarkerElement, createStopMarkerElement, stopLabel, fetchMapboxToken, WAYPOINT_TYPES, getWaypointTypeConfig, addTerrainAndSky, applyTrailEmphasis } from './maps';
import { ElevationChart, WeightChart } from './charts';
import { openGalleryModal } from './gallery';
import * as Utils from './utils';
import * as Constants from './constants';
import { COLORS } from './colors';
import { renderWaypoints, renderWaypointListItem, renderElevationStats } from './route-detail';
import * as Elevation from './elevation';
import { SPANav } from './spa-nav';
import { openFlyover } from './flyover';
import { initTripMap } from './trip-map';
import { startLoadingTextRotation, stopLoadingTextRotation } from './loading-messages';
import { initDatePickerPair } from './datepicker';
import { showToast } from './toast';
import { initElevationChart, startElevationChartObserver, stopElevationChartObserver } from './elevation-auto';
import { updateGearLoadoutQuantity, loadProvisionKitsForModal, previewAndUploadGearPhoto, initGearImagePreview } from './gear';
import './fog-scene'; // Auto-initializes <canvas data-fog-scene> on the landing page


/**
 * Expose Lodestone namespace globally for use in templates
 * Usage: Lodestone.MapManager, Lodestone.ElevationChart, etc.
 */
window.Lodestone = {
    // Map utilities
    getThemeMapStyle,
    createHoverMarkerElement,
    createStopMarkerElement,
    stopLabel,
    fetchMapboxToken,
    WAYPOINT_TYPES,
    getWaypointTypeConfig,
    addTerrainAndSky,
    applyTrailEmphasis,

    // Chart utilities
    ElevationChart,
    WeightChart,

    // Utility functions namespace
    Utils: {
        haversineDistance: Utils.haversineDistance,
        escapeHtml: Utils.escapeHtml,
        formatDistance: Utils.formatDistance,
        formatElevation: Utils.formatElevation,
        sampleCoordinates: Utils.sampleCoordinates,
        detectMention: Utils.detectMention,
        insertMention: Utils.insertMention
    },

    // Unit conversion constants
    Constants: {
        METERS_PER_MILE: Constants.METERS_PER_MILE,
        METERS_PER_KM: Constants.METERS_PER_KM,
        FEET_PER_METER: Constants.FEET_PER_METER,
        GRAMS_PER_KG: Constants.GRAMS_PER_KG,
        GRAMS_PER_LB: Constants.GRAMS_PER_LB
    },

    // Discover cache

    // Route Detail
    renderWaypoints,
    renderWaypointListItem,
    renderElevationStats,

    // Elevation utilities namespace
    Elevation: {
        calculateCumulativeDistances: Elevation.calculateCumulativeDistances,
        calculateElevationGain: Elevation.calculateElevationGain,
        ElevationChartMapSync: Elevation.ElevationChartMapSync
    },

    // SPA Navigation
    SPANav,

    // Flyover (route and trip detail)
    openFlyover,

    // Trip Map
    initTripMap,

    // Loading Messages
    startLoadingTextRotation,
    stopLoadingTextRotation,

    // Datepicker
    initDatePickerPair,

    // Toast
    showToast,

    // Elevation auto-init
    initElevationChart,
    startElevationChartObserver,
    stopElevationChartObserver,

    // Colors
    Colors: COLORS,

    // Gear page
    updateGearLoadoutQuantity,
    loadProvisionKitsForModal,
    previewAndUploadGearPhoto,
    initGearImagePreview,

};

// Expose gallery helper function globally for onclick handlers
window.openGalleryModal = openGalleryModal;

// Expose initElevationChart on window for inline scripts that call window.initElevationChart()
window.initElevationChart = initElevationChart;

// Expose gear functions globally for template event handlers (onchange, data-on:click)
window.updateGearLoadoutQuantity = updateGearLoadoutQuantity;
window.loadProvisionKitsForModal = loadProvisionKitsForModal;
window.previewAndUploadGearPhoto = previewAndUploadGearPhoto;

